var exports = {
  "button": "MediaPlayButton.module__button___SXBNQ1",
  "small": "MediaPlayButton.module__small___SXBNQ1",
  "medium": "MediaPlayButton.module__medium___SXBNQ1",
  "large": "MediaPlayButton.module__large___SXBNQ1",
  "xlarge": "MediaPlayButton.module__xlarge___SXBNQ1",
  "overlay": "MediaPlayButton.module__overlay___SXBNQ1",
};

__webpack_require__.r(module.exports = exports);
